<template>
  <v-container id="adminBotContainer" px-2 fill-height fluid grid-list-xl>
    <v-layout wrap>
      <iframe
        id="chatframe"
        width="100%"
        src="/adminbot/static/innvisichat.html"
      >
      </iframe>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "AdminBot",
  data() {
    return {};
  },
  methods: {}
};
</script>

<style>
#chatframe {
  margin-bottom: 62px;
}
#adminBotContainer {
  margin-left: 0px;
}
</style>
